export enum Achievement {
  // Progression-based
  UNLOCK_EXPLORATION = "unlock_exploration",
  SCHOOL_BASEMENT_CLEAR = "school_basement_clear",
  LIVING_FOREST_CLEAR = "living_forest_clear",
  THUNDER_TOWER_CLEAR = "thunder_tower_clear",
  ELEMENTAL_DUNGEONS_CLEAR = "elemental_dungeons_clear",
  DARK_OVERLORD_DEFEATED = "dark_overlord_defeated",
  TEMPLE_OF_DARKNESS_CLEAR = "temple_of_darkness_clear",

  // Ending-based
  STANDARD_ENDING = "standard_ending",
  CREATION_ENDING = "creation_ending",
  SECRET_ENDING = "secret_ending",

  // New schools
  ALCHEMY_UNLOCKED = "alchemy_unlocked",
  EVOCATION_UNLOCKED = "evocation_unlocked",
  PROTECTION_UNLOCKED = "protection_unlocked",
  BREEDING_UNLOCKED = "breeding_unlocked",
  SUMMONING_UNLOCKED = "summoning_unlocked",
  DIVINATION_UNLOCKED = "divination_unlocked",

  // School mastery
  MASTER_OF_CONJURATION = "master_of_conjuration",
  MASTER_OF_ENCHANTMENT = "master_of_enchantment",
  MASTER_OF_ILLUSION = "master_of_illusion",
  MASTER_OF_ALCHEMY = "master_of_alchemy",
  MASTER_OF_EVOCATION = "master_of_evocation",
  MASTER_OF_PROTECTION = "master_of_protection",
  MASTER_OF_BREEDING = "master_of_breeding",
  MASTER_OF_SUMMONING = "master_of_summoning",
  MASTER_OF_DIVINATION = "master_of_divination",
  ULTIMATE_CONJURATION = "ultimate_conjuration",
  ULTIMATE_ENCHANTMENT = "ultimate_enchantment",
  ULTIMATE_ILLUSION = "ultimate_illusion",
  ULTIMATE_ALCHEMY = "ultimate_alchemy",
  ULTIMATE_EVOCATION = "ultimate_evocation",
  ULTIMATE_PROTECTION = "ultimate_protection",
  ULTIMATE_BREEDING = "ultimate_breeding",
  ULTIMATE_SUMMONING = "ultimate_summoning",
  ULTIMATE_DIVINATION = "ultimate_divination",

  // Other assorted Storylines
  MIMIC = "mimic",
  FAIRY_CIRCLE = "fairy_circle",
  PURPLE_CHAMBER = "purple_chamber",
  REVENGE_ON_THE_BANDITS = "revenge_on_the_bandits",
  SWIFT_START = "swift_start",
  STRENGTHENING_UNLOCKED = "strengthening_unlocked",

  // Other
  ALL_CHALLENGES_CLEARED = "all_challenges_cleared",
  ALL_STORYLINES_COMPLETED = "all_storylines_completed",
}
